import * as React from 'react';
import { useLocation } from 'react-router-dom';

import { WindowLocationService } from '~commonInfra/services/WindowLocationService';

export type UseEffectOnUrlChangeCallback = (newUrl: string, oldUrl: string) => void;

/**
 * Utility hook to call a provided function when the window href changes
 * @param callback - the function to call when the url changes
 * @param deps - the deps array for the provided callback. Same rules apply as usual React hook deps
 */
export function useEffectOnUrlChange(callback: UseEffectOnUrlChangeCallback, deps: any[]) {
  // the location is used here to make sure we get a proper re-render through the react-router instead
  // of just relying on the external value from WindowLocationService. This might not be necessary
  const location = useLocation();
  const newUrl = WindowLocationService.getHref(); // window href because old implementation provided full urls
  const oldUrl = React.useRef(newUrl);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedCallback = React.useCallback(callback, deps);

  React.useEffect(() => {
    memoizedCallback(newUrl, oldUrl.current);
    oldUrl.current = newUrl;
  }, [oldUrl, newUrl, location, memoizedCallback]);
}
